import { Controller } from "@hotwired/stimulus";

// turbo-frame 遷移のたびにアドレスバーURLを遷移先へ同期し、絞り込み等の状態を
// ブックマーク／リロード／共有で再現できるようにする（サーバは params から復元）。
// 検索フォームの変更（検索・リセット）と一覧の変更（ページ送り・並び替え）の両方を
// 1 か所で検知するため、各フレームではなく document でまとめて受ける。
export class FrameUrlSyncController extends Controller {
  connect() {
    this.syncUrl = this.syncUrl.bind(this);
    document.addEventListener("turbo:frame-load", this.syncUrl);
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.syncUrl);
  }

  syncUrl(event) {
    const frame = event.target;
    // 配下フレームのナビゲーションのみ対象（初期表示は src 無しなので除外）
    if (!frame.src || !this.element.contains(frame)) return;
    // 履歴は増やさずURLだけ最新化する
    window.history.replaceState(window.history.state, "", frame.src);
  }
}
